import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { LegacyButton } from './LegacyButton';
import { stripeStore } from '~/lib/stores/stripe';

export const AddStripeKeyButton = memo<{}>(() => {
  const isConfigured = useStore(stripeStore.isConfigured);

  return (
    <LegacyButton
      onClick={stripeStore.openModal}
      variant={isConfigured ? 'secondary' : 'primary'}
      disabled={isConfigured}
    >
      Add Stripe API Key
    </LegacyButton>
  );
});
